export class Customer {
  new = false
  _id = ''
  firstName = ''
  lastName = ''
  playerId = ''
  playerType = 1
  email = ''
  phone = ''
  color = ''
  orders = []

  constructor (newCustomer) {
    this.new = newCustomer
  }
}
